<template>
    <vue-scroll
        :key="outright.outrightsOfferId"
        v-if="outright.outrightsOfferId === selectedOutrightId">
        <div class="single-game-sport">
            <div class="livem-single-event">
                <div class="scroll-single-event">
                    <div class="single-event group-game">
                        <div>
                            <div class="single-event-container lb-sport sportbackcolor-outrights">
                                <div class="sport-icon lb-sport event-bg-sporticon" :class="getSportIconClass(outright)"></div>
                                <div class="single-event-content">
                                    <div class="single-event-top">
                                        <div class="stats-row">
                                            <div class="stats-row-left prematch-event-header" @click="selectOutright({
                                                outrightId: null,
                                                eventType: type,
                                                push: true
                                                })">
                                                <i class="sportsicon icon-arrowleft event-back-icon"></i>
                                                <p class="tournament-time" >{{outright.tree[outright.tree.length - 1].name}}</p>
                                            </div>
                                            <div class="match-outrights-icon">
                                                <img src="../../../assets/img/icon-outrights.svg">
                                            </div>
                                        </div>
                                        <div class="stats-line"></div>
                                    </div>
                                    <div class="single-event-bottom">
                                        <div class="stats-row bottom">
                                            <div class="prematch-teams">
                                                <p class="prematch-stats-team">{{outright.name}}</p>
                                            </div>
                                        </div>
                                        <div class="stats-row bottom">
                                            <div class="stats-row-left">
                                                <p class="tournament-time">{{outright.endDate | formatTicketMatchDate}}</p> <!-- check if date is ok -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <OutrightOutcomes
                    v-if="!outright.shouldRemove"
                    :outright="outright" />
                <div v-else class="singleodds">
                    <div class="single-noodds">
                        <img src="../../../assets/img/error-no-odds.svg">
                        <p>{{$t('NOODDSAVAILABLEATTHISMOMENT')}}</p>
                    </div>
                </div>
                </div>
            </div>
        </div>
    </vue-scroll>
</template>

<script>

import {
    mapActions,
    mapGetters,
} from 'vuex';
import OutrightOutcomes from './OutrightOutcomes.vue';

export default {
    name: 'OutrightSingle',
    props: ['outright', 'type'],
    components:
    {
        OutrightOutcomes,
    },
    created()
    {
        const me = this;

        if (me.isMobile
        || (!me.isMobile && me.smallDesktop))
        {
            window.scroll({
                top: 0,
            });
        }
    },
    methods:
    {
        ...mapActions({
            selectOutright: 'selectOutright',
        }),
        getSportIconClass(outright)
        {
            const me = this;

            const sportMappingValues = Object.values(me.globals.props.sportMapping);

            for (const treeItem of outright.tree)
            {
                const treeItemName = (treeItem.name).toLowerCase();

                if (sportMappingValues.includes(treeItemName))
                {
                    return `sporticon-${treeItemName}`;
                }
            }

            return 'icon-outrights';
        },
    },
    computed:
    {
        ...mapGetters([
            'globals',
            'isMobile',
            'smallDesktop',
            'selectedOutrightId',
        ]),
    },
};
</script>
